import Navbar from "../../components/navbar/Navbar";
// import Leftlayout from "../../components/leftlayout/Leftlayout";
// import Sidebar from "../../components/sidebar/Sidebar";
import LoginPopup from "../login/Login";
import NoticePopup from "../../components/popupfiles/noticepopup/noticePopup";
import ChatPopup from "../../components/popupfiles/chatpopup/chatPopup";
import MainDataTable from "../../components/mainlayout/maindatatable";

const DataTable = () => {
  return (
    <div className="DataTable">
      <Navbar />
      {/* <Leftlayout /> */}
      <LoginPopup />
      <NoticePopup />
      <ChatPopup />
      <MainDataTable />
    </div>
  );
};

export default DataTable;
